import { isReferenceComparisonCriterion } from './comparisonRisk';

export const VERSION_COMPARISON_MULTI_ERROR = 'La comparaison entre versions s’exécute seule. Désélectionnez Comparaison pour lancer les autres critères, ou lancez cette paire séparément.';

export function applyVersionComparisonSelection(selections, criteria, comparison) {
    if (comparison?.mode !== 'document_version') return selections;
    const ids = new Set(criteria.filter(isReferenceComparisonCriterion).map(({ id }) => id));
    if (!selections.some(({ id }) => ids.has(id))) return selections;
    if (selections.length !== 1) throw new Error(VERSION_COMPARISON_MULTI_ERROR);
    if (criteria.some(criterion => criterion.id === selections[0].id && criterion.status?.toLowerCase() === 'completed')) {
        throw new Error('Une comparaison existe déjà pour cette version et ce point de vue. Ses résultats sont conservés.');
    }
    const { referenceId, examinedId, rows, loading, importing } = comparison;
    if (!comparison.viewedVersionId || examinedId !== comparison.viewedVersionId) {
        throw new Error('La comparaison doit examiner la version actuellement consultée.');
    }
    if (!referenceId || !examinedId || referenceId === examinedId) {
        throw new Error('Choisissez deux versions différentes et confirmez le sens référence vers version examinée.');
    }
    if (loading || importing || ![referenceId, examinedId].every(id => (
        rows.some(row => row.document_version_id === id && row.eligible_for_comparison)
    ))) throw new Error('La paire n’est pas prête. Actualisez la liste des versions.');
    return [{
        id: selections[0].id,
        reference_type: 'document_version',
        examined_document_version_id: examinedId,
        reference_document_version_id: referenceId,
    }];
}

const reasons = {
    examined_version: 'Une autre version est nécessaire',
    extraction_processing: 'Préparation en cours',
    extraction_failed: 'Échec de préparation : importez un autre fichier',
    structured_text_unavailable: 'Texte structuré indisponible',
    file_unavailable: 'Fichier indisponible',
    deleted: 'Version supprimée',
    self_comparison_forbidden: 'Choisissez deux versions différentes.',
    examined_version_mismatch: 'La version examinée ne correspond plus au lancement.',
    analysis_rerun_super_admin_only: 'Cette version a déjà été analysée pour ce point de vue. Choisissez une autre version à examiner.',
    version_comparison_must_be_exclusive: VERSION_COMPARISON_MULTI_ERROR,
};

export const comparisonIneligibilityLabel = row => reasons[row.ineligibility_reason] || 'Version indisponible';

export function versionComparisonError(error) {
    const body = error?.response?.data || error?.detail || error;
    const detail = body?.detail || body;
    const code = detail?.code || error?.code;
    const status = error?.response?.status || error?.status;
    const description = reasons[code] || (typeof detail === 'string' ? detail : detail?.message)
        || error?.message || 'La demande n’a pas abouti. Réessayez.';
    return `${status ? `Erreur ${status} : ` : ''}${description}${code && !reasons[code] ? ` (${code})` : ''}`;
}
